/** The "?" dialog: the full keyboard model (UX-SPEC §7). */
import { useUiStore } from '../state/uiStore';
import { Modal } from './Modal';
import './HowToPlay.css';

const GROUPS: { title: string; rows: { keys: string[][]; text: string }[] }[] = [
  {
    title: 'Board',
    rows: [
      { keys: [['←'], ['↑'], ['→'], ['↓']], text: 'Move the cursor' },
      { keys: [['Space']], text: 'Switch typing direction (→ / ↓)' },
      { keys: [['A'], ['–'], ['Z']], text: 'Place a matching tile at the cursor (a blank if you have no match)' },
      { keys: [['Backspace']], text: 'Take back the last tile you placed' },
      { keys: [['Delete']], text: 'Take back the tile under the cursor' },
    ],
  },
  {
    title: 'Turn',
    rows: [
      { keys: [['Enter']], text: 'Play your word' },
      { keys: [['Esc']], text: 'Recall all tiles · close a dialog' },
      { keys: [['Shift', 'S']], text: 'Shuffle your rack' },
      { keys: [['Shift', 'E']], text: 'Exchange tiles' },
      { keys: [['Shift', 'P']], text: 'Pass' },
    ],
  },
  {
    title: 'Rack',
    rows: [
      { keys: [['Tab']], text: 'Move to the rack tiles' },
      { keys: [['Enter'], ['Space']], text: 'Select a tile (then pick a square)' },
      { keys: [['Alt', '←'], ['Alt', '→']], text: 'Move the focused tile within the rack' },
      { keys: [['?']], text: 'Show these shortcuts' },
    ],
  },
];

export function ShortcutsDialog() {
  const open = useUiStore((s) => s.dialog === 'shortcuts');
  const closeDialog = useUiStore((s) => s.closeDialog);
  return (
    <Modal open={open} onClose={closeDialog} title="Keyboard shortcuts" size="md">
      <div className="shortcuts">
        {GROUPS.map((g) => (
          <section key={g.title} className="shortcuts__group">
            <h3 className="eyebrow">{g.title}</h3>
            <dl className="shortcuts__list">
              {g.rows.map((row) => (
                <div key={row.text} className="shortcuts__row">
                  <dt>
                    {row.keys.map((combo, i) => (
                      <span key={i} className="shortcuts__combo">
                        {combo.map((k) =>
                          k === '–' ? (
                            <span key={k} className="shortcuts__dash">
                              –
                            </span>
                          ) : (
                            <kbd key={k} className="kbd">
                              {k}
                            </kbd>
                          ),
                        )}
                      </span>
                    ))}
                  </dt>
                  <dd>{row.text}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </Modal>
  );
}
